import axiosInstance from './axios'
import {AxiosResponse} from "axios";

class MonitoringService {

    constructor(private apiVersion: string = 'v1') {
    }

    public async getDataBaseStatus(): Promise<AxiosResponse> {
        return await axiosInstance.get(`${this.apiVersion}/databasestatus`)
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => {
                throw new Error(error)
            })
    }

    public async geStatesStatus(): Promise<AxiosResponse> {
        return await axiosInstance.get(`${this.apiVersion}/apistatus`)
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => {
                throw new Error(error)
            })
    }
}

const monitoringService = new MonitoringService()

export default monitoringService
